import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 pb-8 border-b border-white/10">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            {/* The wordmark, painted white.
                Previously this was the PNG with `brightness-0 invert`. That
                filter acts on every opaque pixel, so the logo's white ground
                became a solid white rectangle with white letters hidden inside
                it. Masking uses the SVG's alpha instead: colour lands only
                where the glyphs are, and the background stays transparent. */}
            <div
              role="img"
              aria-label="Tenses"
              className="h-8 w-[116px]"
              style={{
                backgroundColor: '#fff',
                WebkitMaskImage: 'url(/tenses-blue-logo.svg)',
                maskImage: 'url(/tenses-blue-logo.svg)',
                WebkitMaskRepeat: 'no-repeat',
                maskRepeat: 'no-repeat',
                WebkitMaskPosition: 'left center',
                maskPosition: 'left center',
                WebkitMaskSize: 'contain',
                maskSize: 'contain',
              }}
            />
            <p className="mt-4 text-white/60 text-sm leading-relaxed">
              Master English communication with AI-powered learning and get globally recognized TPI certification.
            </p>
          </div>

          {/* Product Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Product</h4>
            <ul className="space-y-2">
              <li><Link to="/activities" className="text-sm">Activities</Link></li>
              <li><Link to="/tpi" className="text-sm">TPI Certification</Link></li>
              <li><Link to="/pricing" className="text-sm">Pricing</Link></li>
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Company</h4>
            <ul className="space-y-2">
              <li><Link to="/contact" className="text-sm">Contact</Link></li>
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Support</h4>
            <ul className="space-y-2">
              <li><Link to="/help" className="text-sm">Help Center</Link></li>
              <li><Link to="/faq" className="text-sm">FAQ</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-center md:text-left">
            <p className="text-white/60 text-sm">
              © {new Date().getFullYear()} TALENTSCALE INDIA PRIVATE LIMITED. All rights reserved.
            </p>
          </div>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-white/60 hover:text-white transition-colors text-sm">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-white/60 hover:text-white transition-colors text-sm">
              Terms of Service
            </Link>
            <Link to="/cookies" className="text-white/60 hover:text-white transition-colors text-sm">
              Cookie Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
